import { IconBuildings } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import type { PPAContract } from "../../PPAContractPage.types";

export function getSupplierColumn(
  contracts: Array<PPAContract>
): MRT_ColumnDef<PPAContract> {
  const usedSupplierNames = contracts.map((contract) => contract.supplier.name);
  const sortedAndUniqueSuppliers = Array.from(
    new Set(usedSupplierNames)
  ).sort();

  return {
    accessorKey: "supplier.name",
    header: "Betreiber",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: sortedAndUniqueSuppliers
    },
    Cell: ({ renderedCellValue }) => (
      <MantineIconCell
        IconComponent={IconBuildings}
        renderedCellValue={renderedCellValue}
      />
    )
  };
}
